import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { DocumentTemplate } from '../DocumentTemplate'
import type { ToolsBillOfMaterials } from '@/state'

export const ToolsBillOfMaterialsTable = ({
  id,
  createdAt,
  versionName,
  isLatestDocumentVersion,
  fullScreen,
  order,
  rows,
}: {
  id?: string
  versionName: string
  createdAt: string
  isLatestDocumentVersion?: boolean
  fullScreen?: boolean
  order?: number
  rows: ToolsBillOfMaterials
}) => {
  return (
    <DocumentTemplate
      id={id || `tools-bom`}
      title="Tools Bill of Materials"
      createdAt={createdAt}
      versionName={versionName}
      isLatestDocumentVersion={isLatestDocumentVersion}
      order={order || 4}
      fullScreen={fullScreen}
    >
      <div>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Tool name</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map((item, i) => (
              <TableRow key={i}>
                <TableCell className="py-1 px-2.5">{item.toolName}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </DocumentTemplate>
  )
}
